import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { categoryApi } from "../../../api/categoryApi";
import { storageApi } from "../../../api/storageApi";
import { ResourceType } from "../../../Constants/ResourceType";
import { flashcardApi } from "../../../api/flashcardApi";
import LoadingOverlay from "../../../components/common/LoadingOverlay";
import { aiApi } from "../../../api/aiApi";
import { useLoading } from "../../../context/LoadingContext";
import { AiButton } from "../../../components/common/AIButton";
import { useAlert } from "../../../context/AlertContext";
export default function FlashCardEditPage() {
    const { showAlert } = useAlert();
    const { id } = useParams();
    const { state } = useLocation();

    const [frontText, setFrontText] = useState(state?.frontText || "");
    const [backText, setBackText] = useState(state?.backText || "");
    const [tranliteration, setTranliteration] = useState(state?.transliteration);
    const [usageExample, setUsageExample] = useState(state?.usageExample || "");
    const [fileId, setFileId] = useState(state?.fileId);
    const [previewUrl, setPreviewUrl] = useState(state?.image);
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {
        const handlePaste  = async (e) => {
            const items = e.clipboardData?.items;
            if (!items) return;

            for (let item of items) {
                if (item.type.startsWith("image/")) {
                    const file = item.getAsFile();

                    // 🔥 dùng lại logic cũ
                    await ProcessSetFile(file);

                    break; // chỉ lấy 1 ảnh
                }
            }
        };

        window.addEventListener("paste", handlePaste);
        return () => window.removeEventListener("paste", handlePaste);
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const param = {
                "categoryId": state?.categoryId || "",
                "id": state?.id || "",
                "frontText": frontText,
                "backText": backText,
                "transliteration": tranliteration,
                "fileId": fileId,
                "usageExample": usageExample
            }
            showLoading();
            const res = await flashcardApi.update(param);
            showAlert("success", "Successfully updated flashcard");
            window.history.back();
        }
        finally {
            hideLoading();
        }
    };
    const handleAutoGen = async () => {
        try {
            const param = {
                "message": frontText
            }
            showLoading();
            const res = await aiApi.genTranslateTextOpenAi(param);
            if (res.success) {
                const message = res.data.targetLang;
                const trans = res.data.transliteration;
                const usageExample = res.data.usageExample;
                if (message) {
                    setBackText(message);
                    setTranliteration(trans);
                    setUsageExample(usageExample);
                }
            }
        }
        finally {
            hideLoading()
        }
    }
    const handleSetFile = async (e) => {
        const file = e.target.files[0];
        if (file) {
            await ProcessSetFile(e);
        }
    }
    const ProcessSetFile = async (file) => {
        try {
            const form = new FormData();
            form.append("file", file);
            showLoading();
            const rs = await storageApi.uploadTemptFile(form);
            if (rs.success) {
                const id = rs.data.id;
                const url = rs.data.url;
                setFileId(id);
                setPreviewUrl(url);
            }
        }
        finally {
            hideLoading();
        }
    }
    const HandleAutoGenImage = async () => {
        try {
            showLoading();
            const param = {
                "message": frontText
            }
            const rs = await aiApi.genText2Image(param);
            if (rs.success) {
                const data = rs.data;
                setPreviewUrl(data.url);
                setFileId(data.id)
            }
        }
        finally {
            hideLoading();
        }
    }
    return (
        <div className="container mt-4" style={{ maxWidth: "600px" }}>
            <h3 className="mb-3">Edit FlasCard #{id}</h3>

            <form onSubmit={handleSubmit}>

                {/* Name */}
                <div className="mb-3">
                    <label className="form-label fw-bold">FrontText</label>
                    <textarea
                        className="form-control"
                        value={frontText}
                        onChange={(e) => setFrontText(e.target.value)}
                    />
                </div>

                {/* Description */}
                <div className="row mb-3">
                    <label className="form-label fw-bold">BackText</label>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            rows="3"
                            value={backText}
                            onChange={(e) => setBackText(e.target.value)}
                        />
                        <textarea
                            className="form-control"
                            rows="1"
                            placeholder="Transliteration"
                            value={tranliteration}
                            onChange={(e) => setTranliteration(e.target.value)}
                        />
                        <input
                            className="form-control"
                            placeholder="Usage Example"
                            value={usageExample}
                            onChange={(e) => setUsageExample(e.target.value)}
                        />
                    </div>
                    <div className="col">
                        <AiButton onClick={handleAutoGen}> Auto gen
                        </AiButton>
                    </div>
                </div>

                {/* File Upload */}
                <div className="mb-3">
                    <label className="form-label fw-bold">Image</label>
                    <div className="row">
                        <div className="col-9">
                            <input
                                className="form-control"
                                type="file"
                                accept="image/*"
                                onChange={handleSetFile}
                            />
                        </div>
                        <div className="col">
                            <AiButton onClick={HandleAutoGenImage}
                            >Auto gen</AiButton>
                        </div>
                    </div>
                </div>

                {/* Preview Image */}
                {previewUrl && (
                    <div className="mb-3">
                        <img
                            src={previewUrl}
                            alt="preview"
                            style={{
                                width: "100%",
                                borderRadius: "8px",
                                objectFit: "cover",
                            }}
                        />
                    </div>
                )}

                {/* Save */}
                <button type="submit" className="btn btn-primary me-2">
                    Save Changes
                </button>

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => window.history.back()}
                >
                    Cancel
                </button>

            </form>
        </div>
    );
}
